import * as React from "react";
import { useScreenContext } from "./screenContext";
import { useSelector } from "react-redux";
import { useEmailDataContext } from "./dataContext";
import Domain from "../taskpane/components/login/domain";
import EmailConfig from "../taskpane/components/emailConfig/EmailConfig";
import Content from "../taskpane/components/content/content";
import AppHeader from "./appHeader";
import NonSub from "./nonSub";
import Login from "../taskpane/components/login/login";

export default function ScreenRouting() {
  const { currentScreen } = useScreenContext();
  const user = useSelector((state) => state.authReducer.user);
  const system = useSelector((state) => state.systemReducer);
  const { subscriber } = useEmailDataContext();

  const mainAppSwitch = () => {
    switch (currentScreen) {
      case "/":
        return <EmailConfig />;
      case "/content":
        return <Content />;
      default:
        return <EmailConfig />;
    }
  };

  if (user.current_user && system.hasOwnProperty("subdomain")) {
    if (subscriber) {
      return (
        <div className="app-content-wrapper">
          <AppHeader />
          {mainAppSwitch()}
        </div>
      );
    } else {
      return <NonSub />;
    }
  } else {
    switch (currentScreen) {
      case "/":
        return <Domain />;
      case "/login":
        return <Login />;
      default:
        return <Domain />;
    }
  }
}
